
import type { PerformanceCore } from './performanceCore';

/**
 * Tracks interaction-related performance metrics
 */
export class PerformanceInteractionTracker {
  private core: PerformanceCore;
  
  constructor(core: PerformanceCore) {
    this.core = core;
  }
  
  trackInteractionTiming(entry: PerformanceEventTiming) {
    // Only track significant interactions (e.g., slow clicks)
    if (entry.duration > 100) { // Over 100ms is a slow interaction
      // Track as INP candidate
      this.core.trackPerformanceEvent({
        category: 'performance',
        action: 'slow_interaction',
        label: entry.name,
        value: Math.round(entry.duration),
        metadata: {
          targetElement: entry.target?.toString() || 'unknown',
          duration: entry.duration,
          processingTime: entry.processingStart ? (entry.processingEnd || 0) - entry.processingStart : 0,
          startTime: entry.startTime
        }
      });
    }
  }
}
